<template>
<div :class="$style['obs-question-message']">
    <pt-sub-title title="问答相关信息"></pt-sub-title>
    <table>
     <pt-form-list-item label="签约产科问答：" required>
        <wt-radio :radios="questionRadios" v-model="formValue.joinObstetricsQA"></wt-radio>
      </pt-form-list-item>
      <template v-if="join_obstetricsQA">
      <pt-form-list-item label="医生头像：" required>
         <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
            v-model="formValue.idPhoto" data-vv-as="医生头像" name="name"  v-validate="'required'" :multiple="false">
            <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
          </wt-upload-file>
          <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：100*100像素；建议分辨率：72dpi；图片格式：.jpg、.png</div>
      </pt-form-list-item>
      <pt-form-list-item label="产科问答医院：" required>
        <wt-selector :options="hospitalList" filterable v-model="formValue.qaHospitalIds" :props="hospitalListProps" name="hospital"  v-validate="'required'" ></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="医生擅长：" required>
        <wt-input placeholder="请输入商品医生擅长...(限制50个字)" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}"
            :class="$style['input-style']"   v-model="formValue.excellent" data-vv-as="医生擅长" name="name"  v-validate="'required'"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="医生简介：" required>
        <wt-input placeholder="请输入商品医生简介...(限制50个字)" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}"
            :class="$style['input-style']"   v-model="formValue.introduction" data-vv-as="医生简介" name="name"  v-validate="'required'"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="是否消费积分：" required>
           <wt-radio :radios="questionRadios" v-model="needPoints"></wt-radio>
      </pt-form-list-item>
       <pt-form-list-item label="提问分值：" required>
          <wt-input  style="display:none" v-model="canQuestion" data-vv-as="至少开启一个可提问等级" name="name"  v-validate="'required|selectArr'" ></wt-input>
         <table>
           <tr>
             <td>允许提问</td>
             <td class="integral-goods-of-leval">等级</td>
             <td>分值</td>
           </tr>
           <tr v-for="(item,index) in questionScore" :key="index">
             <td><el-switch v-model="item.allowQuestions"></el-switch></td>
             <td class="integral-goods-of-leval">{{item.name}}</td>
             <td><wt-input v-model="item.points"></wt-input></td>
           </tr>
         </table>
       </pt-form-list-item>
      </template>
    </table>
</div>
</template>
<script>
import { questionRadios } from '../../hospital-and-doctor-manage'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    allMembers: {
      type: Array,
      default: function () {
        return []
      }
    },
    data: {
      type: Object,
      default: function () {
        return {
          qaExtendInfo: {}
        }
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    hospitalList: Array
  },
  data () {
    return {
      questionRadios: questionRadios,
      formValue: {
        qaExtendInfo: {}
      },
      uploadApi: this.$uploadApi,
      privateResourcesUrl: this.$publicResourcesUrl,
      picture_params: {
        resourceName: 'avatar'
      },
      questionScore: this.allMembers,
      needPoints: false,
      canQuestion: 0,
      hospitalListProps: {
        label: 'name',
        value: 'id'
      }
    }
  },
  computed: {
    need_points () {
      return this.needPoints === 'true'
    },
    join_obstetricsQA () {
      return this.formValue.joinObstetricsQA === 'true'
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.formValue = JSON.parse(JSON.stringify(val)) || { qaExtendInfo: {} }
        this.needPoints = this.formValue.qaExtendInfo && (this.formValue.qaExtendInfo.needPoints + '')
        this.questionScore = this.formValue.qaExtendInfo.memberConfigure || []
      }
    },
    allMembers: {
      handler: function (val) {
        this.questionScore = (this.questionScore && this.questionScore.length) ? this.questionScore : val
        if (!this.isEdit) {
          this.questionScore.forEach(item => {
            item.allowQuestions = true
          // item.allowQuestions = this.isEdit ? item.allowQuestions : true
          })
        }
      }
    },
    questionScore: {
      handler: function (val) {
        this.formValue.qaExtendInfo = this.formValue.qaExtendInfo || {}
        this.formValue.qaExtendInfo.memberConfigure = val
        this.canQuestion = 0
        val.forEach(item => {
          if (item.allowQuestions) {
            this.canQuestion++
          }
        })
      },
      deep: true
    },
    formValue: {
      handler: function (val) {
        let data = {
          ...val,
          joinObstetricsQA: this.join_obstetricsQA,
          qaExtendInfo: {
            needPoints: this.need_points,
            memberConfigure: this.questionScore
          }
        }
        this.$emit('input', data)
      },
      deep: true
    }
  }
}
</script>
<style module lang="less">
.obs-question-message{
  :global{
    .integral-goods-of-leval{
      padding-left: 20px;
      padding-right: 20px
    }
  }
}
.upload-tips-text{
    line-height: 40px;
    font-size: 14px;
}
</style>
